// Section 11.7 — synthetic stroke fixture from the Power Gates Integration spec.
// Used to verify all Layer 4 algorithms before BLE hardware is available.

export const mockStroke = {
  forceN:    [0,   15,  80,  210, 380, 420, 390, 310, 180, 90, 30, 5,  0],
  angleDeg:  [-60, -55, -45, -30, -15, 0,   15,  30,  45,  55, 62, 67, 70],
};

export const mockRigging = {
  ol: 288,    // cm
  ib: 88,     // cm
  sp: 87,     // cm  (Spread, added in spec update)
  zf: 0,      // N
  za: 0,      // deg
  mfw2: false,
};

export const mockBoatSpeed = 4.2;   // m/s
export const mockSpm = 24;

// Expected outputs (from spec):
//   CA  ≈ -55°
//   FA  ≈ +67°
//   EL  ≈ 122°
//   MXF ≈ 420 N
//   MFA ≈ 0°
//   OPW ≈ ~180 W
// Theoretical angles (derived):
//   theoretical_CA = -arccos(87/288) ≈ -72.42°
//   theoretical_FA = +arccos(87/288) ≈ +72.42°
//   SL  = -72.42 - (-55)   ≈ -17.42°  (negative => blade entered before theoretical max)
//   WA  =  67 - 72.42      ≈  -5.42°  (negative => blade extracted before theoretical max)
export const expected = {
  CA: -55,
  FA: 67,
  EL: 122,
  MXF: 420,
  MFA: 0,
  OPW_min: 150,
  OPW_max: 250,
  theoretical_CA_approx: -72.42,
  theoretical_FA_approx: +72.42,
  SL_approx: -17.42,
  WA_approx: -5.42,
};
